import { CustomToastComponent } from "@/components/shared";
import { UpdateCustomerNameDocument, UpdateCustomerNameMutation, UpdateCustomerNameMutationVariables } from "@/graphql/__generated__/graphql";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export default function useUpdateCustomerNamekMutationHook() {
  const { t } = useTranslation(["toasts"]);

  const [updateCustomerNameMutation, { loading, error }] = useMutation<UpdateCustomerNameMutation, UpdateCustomerNameMutationVariables>(
    UpdateCustomerNameDocument, {
      onCompleted: () => {
        toast(CustomToastComponent, {
          toastId: "customer-name-update-success",
          data: {
            title: t("toasts.customernameupdatedsuccess"),
            type: "success",
          }
        });
      }
    });

  return {
    updateCustomerNameMutation,
    loading,
    error
  };
}
